//@flow
import { connect } from 'react-redux';
import RoamingOffer, { type StateProps } from './RoamingOffer';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';
import { selectedRoamingPackageZoneSelector } from '../../modules/International/Roaming/reducer';
import type { StateType } from '../../modules/reducers';

const mapStateToProps = (state: StateType): StateProps => ({
  roamingCountryZone: selectedRoamingPackageZoneSelector(state),
  isLoading: isLoadingSelector(state, 'roamingOffer'),
});

export default connect(mapStateToProps)(RoamingOffer);
